import { createContext } from 'react'

// DOM node of the header's actions slot; a view portals its own header
// controls (e.g. the analytics chart catalogue) into it.
export const BirdviewHeaderActionsContainer = createContext(null)
